import { render, staticRenderFns } from "./SasaranKinerjaTutup.vue?vue&type=template&id=0ec58514&scoped=true&lang=html&"
import script from "./SasaranKinerjaTutup.vue?vue&type=script&lang=js&"
export * from "./SasaranKinerjaTutup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec58514",
  null
  
)

export default component.exports